import { makeStyles } from "@fluentui/react-components";
import * as React from "react";
import { common } from "../../../strings";
import { useAuth } from "../../AuthContext";

const logoutstr = common();

// Components
import { Avatar, Button, Menu, MenuItem, MenuPopover, MenuTrigger } from "@fluentui/react-components";

const useStyles = makeStyles({
  accountIcon: {
    marginRight: "25px",
    marginBottom: "3px",
  },
});

const LogoutButton = () => {
  const { logout, user } = useAuth();
  const styles = useStyles();

  return (
    <Menu>
      <MenuTrigger>
        <Button
          aria-label="More"
          icon={<Avatar name={user?.nickname || user?.name} />}
          appearance="transparent"
          className={styles.accountIcon}
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuItem onClick={() => window.open("https://issuesform.z19.web.core.windows.net/", "_blank")}>
          Report Issue
        </MenuItem>
        <MenuItem onClick={logout}>{logoutstr.logout}</MenuItem>
      </MenuPopover>
    </Menu>
  );
};

export { LogoutButton };
